import type { OnInit } from '@angular/core';
import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { LerbComponent } from '../lerb/lerb.component';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import type { AVMProduct } from '@helsana/lerb-finder';
import { Language, LerbFinderMode } from '@helsana/lerb-finder';

@Component({
  standalone: true,
  selector: 'lerb-wrapper', // tslint:disable-line
  templateUrl: './lerb-wrapper.component.html',
  styleUrls: ['./lerb-wrapper.component.scss'],
  imports: [LerbComponent, RouterModule, RouterOutlet],
  encapsulation: ViewEncapsulation.None
})
export class LerbWrapperComponent implements OnInit {
  @Input() mode!: LerbFinderMode | undefined;
  @Input() language!: Language | undefined;
  @Input() host!: string | undefined;
  @Input() product!: AVMProduct | undefined;
  @Input() initialType!: string | undefined;
  @Input() isOverlayMode = true;
  private router = inject(Router);

  constructor() {}

  ngOnInit() {
    this.router.initialNavigation();
    if (typeof this.isOverlayMode === 'string') {
      this.isOverlayMode = JSON.parse(this.isOverlayMode);
    }
  }

  public getMode(): LerbFinderMode {
    return this.mode || LerbFinderMode.Provider;
  }

  public getLanguage(): Language {
    return this.language || Language.de;
  }

  public getProduct(): AVMProduct | undefined {
    return this.product;
  }

  public getHost(): string {
    return this.host || '';
  }
  public getInitialType(): string {
    return this.initialType || '';
  }

  public getIsOverlayMode(): boolean {
    return this.isOverlayMode;
  }
}
